import { useTranslation } from 'next-i18next'
import { useEffect, useState } from 'react'

import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { useGetUserChosenCurriculumCountryCode } from '~/curriculum/hooks/useGetCurriculumCountryCode'
import { useGetUserLocationInfoFromIpQuery } from '~/redux/apis/geo-location-api'
import { getIntroItems, getSponsers } from '~/start/constants'

export default function Sponsers(): React.ReactElement {
  const { t } = useTranslation(['start', 'register', 'subscription', 'landing'])
  const [introItems, setIntroItems] = useState(() => getIntroItems(''))
  const curriculumCountryCode = useGetUserChosenCurriculumCountryCode()
  const { data: geoLocation } = useGetUserLocationInfoFromIpQuery()
  const sponsers = getSponsers(geoLocation?.countryCode)

  useEffect(() => {
    setIntroItems(getIntroItems(curriculumCountryCode))
  }, [curriculumCountryCode])

  return (
    <div className="relative bg-white">
      <div className="w-full bg-white mx-auto">
        <div className="flex justify-center px-2">
          <ul className="flex gap-2 md:gap-4 lg:gap-8 justify-between md:justify-center w-full max-w-96 md:max-w-250 flex-wrap pt-3 pb-2 text-xs md:text-sm text-gray-slate">
            {introItems.map(({ iconComponent, text, iconSize, className }) => (
              <li className={`flex items-center gap-1 md:min-w-0 ${className}`} key={text}>
                <SVGIcon icon={iconComponent} pathClassName="text-purple" size={iconSize} />
                {text && <p className="truncate">{t(`start:${text}`)}</p>}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="w-full bg-white mx-auto ">
        <div className="flex justify-center px-4">
          <div className="flex flex-col items-center justify-center">
            <p className="text-center text-gray-slate mx-auto md:mt-2 mb-1 md:mb-0">{t('landing:intro.partnership')}</p>
            <ul className="flex justify-center gap-2 md:gap-4 flex-wrap mb-3 md:pt-2 text-xs md:text-sm text-white mx-auto">
              {sponsers.map(({ icon, altKey, height, width, className }) => (
                <li className="flex items-center min-w-0 gap-2" key={altKey}>
                  <ResponsiveImage
                    alt={t(`start:${altKey}`)}
                    className={className || ''}
                    height={height}
                    srcKey={icon}
                    width={width}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}
